import React from "react";
import { type Control, Controller, get, useFormState } from "react-hook-form";
import { Input } from "@flixbus/honeycomb-react";
import type { AddCostFormValues } from "../../CostPanel.types";
import { decimalPattern } from "./addCostSchema";

interface NumberFieldProps {
  name: string;
  id: string;
  label: string;
  ariaLabel?: string;
  extraClasses?: string;
  unit?: string;
  control: Control<AddCostFormValues>;
  onGridPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
}

const NumberField: React.FC<NumberFieldProps> = ({
  name,
  id,
  label,
  ariaLabel,
  extraClasses,
  unit,
  control,
  onGridPaste,
}) => {
  const { errors } = useFormState({ control, name });
  // `get` resolves a react-hook-form error at a dot-path field name
  // (e.g. "var.2026-01"), since PER_MONTH fields are validated as a nested object.
  const errorMessage = get(errors, name)?.message as string | undefined;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <Input
          id={id}
          label={label}
          aria-label={ariaLabel}
          type="text"
          inputMode="decimal"
          inlineLabelRight={unit || undefined}
          extraClasses={extraClasses}
          innerRef={ref}
          value={(value as string) ?? ""}
          onBlur={onBlur}
          onChange={(event) => {
            const next = event.target.value;
            if (decimalPattern.test(next)) onChange(next);
          }}
          onPaste={onGridPaste}
          valid={errorMessage ? false : undefined}
          infoError={errorMessage}
        />
      )}
    />
  );
};

export default React.memo(NumberField);
